module.exports = __webpack_public_path__ + "img/_PWK2749_-PSedit_.85a2f154.jpeg";